export * from './integrations';
export { EventKey } from './event-bus';
import { EventBus } from './event-bus';

export const eventBus = EventBus.getInstance();
